import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetAutoTemplatesQuery,
  GetAutoTemplatesQueryVariables,
  GetAutoTemplateUnauthedQuery,
  GetAutoTemplateUnauthedQueryVariables,
  GetAutoTemplateQuery,
  GetAutoTemplateQueryVariables,
} from "./AutoTemplates.generated";

export const GET_AUTO_TEMPLATES: TypedDocumentNode<
  GetAutoTemplatesQuery,
  GetAutoTemplatesQueryVariables
> = gql`
  query GetAutoTemplates($isFavourite: Boolean, $teamUuid: String) {
    autoTemplates(isFavourite: $isFavourite, teamUuid: $teamUuid) {
      uuid
      name
      templateType
      description
      templateType
      isFavourite
      userPreferences
      sharingType
      sharedEmails
      teamDefaults
      createdAt
      updatedAt
      user {
        uuid
        firstName
        lastName
        teams {
          uuid
          name
          organization {
            uuid
          }
        }
      }
    }
  }
`;

export const GET_AUTO_TEMPLATE_BY_UUID_NO_AUTH: TypedDocumentNode<
  GetAutoTemplateUnauthedQuery,
  GetAutoTemplateUnauthedQueryVariables
> = gql`
  query GetAutoTemplateUnauthed($uuid: UUID!) {
    autoTemplateById(uuid: $uuid) {
      uuid
      name
      description
      templateType
      sharingType
      userPreferences
      teamDefaults
      user {
        firstName
        lastName
        uuid
        teams {
          uuid
          name
          organization {
            uuid
          }
        }
      }
      fields {
        uuid
        fieldName
        fieldIdx
        fieldValue
      }
    }
  }
`;

export const GET_AUTO_TEMPLATE_BY_UUID: TypedDocumentNode<
  GetAutoTemplateQuery,
  GetAutoTemplateQueryVariables
> = gql`
  query GetAutoTemplate($uuid: UUID!) {
    autoTemplateById(uuid: $uuid) {
      uuid
      name
      description
      templateType
      isFavourite
      userPreferences
      sharingType
      sharedEmails
      teamDefaults
      createdAt
      updatedAt
      user {
        uuid
        firstName
        lastName
        teams {
          uuid
          name
          organization {
            uuid
          }
        }
      }
      fields {
        uuid
        fieldName
        fieldIdx
        fieldValue
      }
      templatePreviews {
        uuid
        previewContent
      }
    }
  }
`;
